module.exports = __webpack_public_path__ + "icon-close-modal.png";